<template>
  <div class="shopadmin-home">
    <div class="shopadmin-home-tabs__bar" ref="bar">
      <div class="shopadmin-home-tabs__tab-row" role="tablist">
        <button
          type="button"
          class="shopadmin-home-tabs__tab shopadmin-home-tabs__tab--home"
          :class="{ 'shopadmin-home-tabs__tab--active': activeTab === 'home' }"
          role="tab"
          :aria-selected="activeTab === 'home'"
          @click="switchTab('home')"
        >
          <span class="shopadmin-home-tabs__tab-label" ref="labelHome">HOME</span>
        </button>
        <button
          type="button"
          class="shopadmin-home-tabs__tab"
          :class="{ 'shopadmin-home-tabs__tab--active': activeTab === 'titan' }"
          role="tab"
          :aria-selected="activeTab === 'titan'"
          @click="switchTab('titan')"
        >
          <span class="shopadmin-home-tabs__tab-label" ref="labelTitan">
            <span class="shopadmin-home-tabs__new-badge">新機能</span>
            <span class="shopadmin-home-tabs__tab-text">インバウンド集客 (TITAN)</span>
          </span>
        </button>
      </div>
      <div class="shopadmin-home-tabs__indicator" :style="indicatorStyle"></div>
    </div>

    <div v-show="activeTab === 'home'" class="contents">
      <shopadmin-messages></shopadmin-messages>
      <h3 class="ui dividing header">お知らせ</h3>
      <shopadmin-announcements></shopadmin-announcements>
      <h3 class="ui dividing header">通知</h3>
      <shopadmin-notifications></shopadmin-notifications>
    </div>

    <div v-show="activeTab === 'titan'" class="contents shopadmin-titan-panel-outer">
      <div class="shopadmin-titan-panel">
        <tlp></tlp>
      </div>
    </div>
  </div>
</template>

<script>
import ShopadminMessages from './messages.vue';
import ShopadminAnnouncements from './announcements.vue';
import ShopadminNotifications from './notifications.vue';
import ShopadminTitanLp from './titanLp.vue';

export default {
  name: 'shopadmin-home-tabs',
  components: {
    'shopadmin-messages': ShopadminMessages,
    'shopadmin-announcements': ShopadminAnnouncements,
    'shopadmin-notifications': ShopadminNotifications,
    tlp: ShopadminTitanLp,
  },
  data() {
    return {
      activeTab: 'home',
      indicatorStyle: { left: '0px', width: '0px' },
    };
  },
  mounted() {
    this.$nextTick(() => this.updateIndicator());
  },
  methods: {
    switchTab(tab) {
      this.activeTab = tab;
      this.$nextTick(() => this.updateIndicator());
    },
    updateIndicator() {
      const labelRef = this.activeTab === 'home' ? this.$refs.labelHome : this.$refs.labelTitan;
      const bar = this.$refs.bar;
      if (!labelRef || !bar) return;
      const labelRect = labelRef.getBoundingClientRect();
      const barRect = bar.getBoundingClientRect();
      this.indicatorStyle = {
        left: (labelRect.left - barRect.left) + 'px',
        width: labelRect.width + 'px',
      };
    },
  },
};
</script>
